import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { HeroRightMain } from "../../constant/imagePath";
import Button from "../Button/Button";
import classes from "./HeroSection.module.css";
import parse from "html-react-parser";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Index = ({
  heading,
  text,
  bgImage,
  foregroungImage,
  foregroungImageHash,
  bgImageHash,
}) => {
  const navigate = useNavigate();
  const token = useSelector((state) => state?.authReducer?.access_token);

  // const [isLoaded, setLoaded] = useState(false);
  // const [isLoadStarted, setLoadStarted] = useState(false);

  // const handleLoad = () => {
  //   setLoaded(true);
  //   console.log("Ended: -----------");
  // };

  // const handleLoadStarted = () => {
  //   setLoadStarted(true);
  // };

  return (
    <>
      {/* Hero Section */}
      <section
        className={classes.heroSection}
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className={classes.overLay}>
          {/* <Header bgTransparent={true} /> */}
          <Container fluid className={classes.container}>
            <Row className={classes.row}>
              <Col xl={5} lg={12}>
                <div className={classes.leftContent}>
                  {/* <span className={classes.welcomeTo}>Welcome To</span>
                  <h1>{heading}</h1> */}
                  {heading && (
                    <span className={classes?.quillHeading}>
                      {parse(heading)}
                    </span>
                  )}
                  <p>{text}</p>
                  <div className={classes.btnsBox}>
                    <Button
                      label={"Explore"}
                      className={classes.exploreBtn}
                      onClick={() => navigate("/cards")}
                    />
                    {/* <a className={classes.exploreBtn} href="#recentlyAdded">
                      Explore
                    </a> */}
                    <Button
                      label={"Create Card"}
                      className={classes.createCardBtn}
                      onClick={() => {
                        // if (!token) return toast.warn("Please login first.");
                        navigate("/template");
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col className={classes.imageColMain} md={7}>
            
                <div
                  className={classes.bg_img}
                  // style={{ visibility: isLoaded ? "visible" : "hidden" }}
                >
                  <img src={foregroungImage} />
                  {/* <LazyLoadImage
                    src={foregroungImage}
                    onLoad={handleLoad}
                    beforeLoad={handleLoadStarted}
                  /> */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* End of Hero Section */}
    </>
  );
};

export default Index;
